// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__m4bDU","inner":"Footer_inner__3H2Ln","nextIcon":"Footer_nextIcon__3T8ly","innerLeft":"Footer_innerLeft__JFDFB"};